import { h } from "preact";
import { QuantityMinus, QuantityPlus } from "../../helpers/icons";

export default function QuantityInput({ quantity, setQuantity, max }) {
  return (
    <div className="quantity">
      <button
        className="quantity__button quantity__button--decrease"
        name="minus"
        type="button"
        disabled={quantity <= 0}
        onClick={() => setQuantity(quantity - 1)}
      >
        <span className="visually-hidden">
          {window.localeStrings.product.quantity_decrease}
        </span>
        <QuantityMinus />
      </button>
      <label className="quantity__input-label">
        <span className="visually-hidden">
          {window.localeStrings.product.quantity}
        </span>
        <input
          className="quantity__input"
          type="number"
          name="quantity"
          min="0"
          max={max}
          step="1"
          value={quantity}
          onChange={(e) =>
            setQuantity(
              max !== null
                ? Math.min(max, parseInt(e.target.value))
                : parseInt(e.target.value),
            )
          }
        />
      </label>
      <button
        className="quantity__button quantity__button--increase no-js-hidden"
        name="plus"
        type="button"
        disabled={max > 0 && quantity >= max}
        onClick={() => setQuantity(quantity + 1)}
      >
        <span className="visually-hidden">
          {window.localeStrings.product.quantity_increase}
        </span>
        <QuantityPlus />
      </button>
    </div>
  );
}
